import { MDText } from 'i18n-react';

import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { BackgroundLayout } from 'Components/BackgroundLayout';
import { triggerPaidListingFAQLinkClicked } from 'Services/analytics/events';

import { ReactComponent as MoneyHandIcon } from '../../moneyHandIcon.svg';
import paidListingsTexts from '../../paidListings.texts';

import styles from './PaidListingInfoBox.module.scss';

const LocalT = new MDText(paidListingsTexts);

const HELP_CENTRE_URL = 'https://help.dealers.motorway.co.uk/hc/en-gb/articles/24281959822108-Paid-listings';

export const PaidListingInfoBox = () => {
	return (
		<BackgroundLayout backgroundColour="light" border="light" className={styles.layout}>
			<div className={styles.iconTextContainer}>
				<MoneyHandIcon className={styles.icon} height={20} width={20} />
				<h2>{LocalT.translate(paidListingsTexts.infoBox.title)}</h2>
			</div>
			<p className={styles.paidInfoText}>
				{LocalT.translate(paidListingsTexts.infoBox.description, {
					FAQ: (
						<Hyperlink
							as="a"
							href={HELP_CENTRE_URL}
							label={LocalT.translate(paidListingsTexts.infoBox.faqs)}
							onClick={triggerPaidListingFAQLinkClicked}
							target="_blank"
						/>
					),
				})}
			</p>
		</BackgroundLayout>
	);
};
